<ng-container>
  <div class="warning-badge"><i class="material-icons icon">warning</i>
    <div class="description">The changes will be applied starting from newly created sites. Existing sites will not be affected.</div>
  </div>
  <div style="display: flex;justify-content: end;padding: 6px 20px;">
    <div class="btn-area" *ngIf="isEditMode" style="gap: 8px;">
      <div class="button button-white" (click)="onClickCancel()">
        <div class="btn-inner">Cancel</div>
      </div>
      <div class="button button-primary" [class.disabled]="isDisabledSave()" (click)="onClickSave()">
        <div class="btn-inner">Save</div>
      </div>
    </div>
    <div class="btn-area" *ngIf="!isEditMode">
      <div class="button button-white" (click)="isEditMode = true">
        <div class="btn-inner">Edit</div>
      </div>
    </div>
  </div>
  <div class="tab-table">
    <div class="table-area">
      <div class="content-body table-container" [class.is-edit-mode]="isEditMode">
        <table class="table-header">
          <colgroup>
            <col *ngFor="let col of tableHeader" [width]="col.width"/>
          </colgroup>
          <thead>
            <tr>
              <th *ngFor="let header of tableHeader">
                 {{header.name}}
                <input *ngIf="header.isCheckbox" type="checkbox" [checked]="isAllSelected" (click)="toggleAllCheckbox()"/>
              </th>
            </tr>
          </thead>
        </table>
        <div class="loader absolute" *ngIf="isLoading">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
          </svg>
        </div>
        <div class="table-body" *ngIf="!isLoading">
          <table style="width: 100%">
            <colgroup>
              <col *ngFor="let col of tableHeader" [width]="col.width"/>
            </colgroup>
            <tbody>
              <tr>
                <td>
                  <div class="between">Zone Number Range
                    <div class="tooltip-content" id="zone-number-tooltip-box" (mouseenter)="setTooltipPosition('zone-number-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="zone-number-tooltip">This setting configures the logic for assigning zone numbers automatically whenever a new camera is added to the site. The number you set will be assigned to the first camera, and subsequent cameras will receive zone numbers incrementally in the order they are installed.</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">101</div>
                </td>
                <td> 
                  <div *ngIf="!isEditMode">{{ originSiteSettings.zoneNumberRange }}</div>
                  <div class="v-center" *ngIf="isEditMode"> 
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="zoneNumberRange" [(ngModel)]="newSiteSettings.zoneNumberRange" [min]="1" [max]="599" (keyup)="validateZoneNumberRange()" (change)="validateZoneNumberRange()"/>
                    </div>
                    <div class="range-description">Range: 1 - 599</div>
                    <div class="warning" *ngIf="isHasError.zoneNumberRange">Please enter a value within the allowed range.</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Alarm Event Interval</div>
                    <div class="tooltip-content" id="event-interval-tooltip-box" (mouseenter)="setTooltipPosition('event-interval-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="event-interval-tooltip">
                        <div style="font-size: 16px">Alarm Event Interval</div>
                        <div class="flex" style="margin: 24px 0; justify-content: center"><img src="/assets/imgs/alarm_interval_tooltip.png" style="width: 200px; height: 100%; border-radius: 0"/></div>
                        <div>It does not forward consecutive events that occur during the set period.</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">20s</div>
                </td>
                <td> 
                  <div *ngIf="!isEditMode">{{originSiteSettings.alarmInterval}}s</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="alarmInterval" [(ngModel)]="newSiteSettings.alarmInterval" [min]="10" [max]="3600" (keyup)="validateAlarmInterval()" (change)="validateAlarmInterval()"/><span class="suffix">s</span>
                    </div>
                    <div class="range-description">Range: 10s - 3600s</div>
                    <div class="warning" *ngIf="isHasError.alarmInterval">Please enter a value within the allowed range.</div>
                    <div class="warning" *ngIf="isHasError.over20">
                       MP4 length exceeds Alarm Event Interval.<br/>
                      Set Alarm Event Interval to <b>{{ newSiteSettings.mp4VideoSettings.post }}s</b> or higher to prevent duplicates.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Swinger Bypass</div>
                    <div class="tooltip-content" id="swinger-bypass-tooltip-box" (mouseenter)="setTooltipPosition('swinger-bypass-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="swinger-bypass-tooltip">
                        <div style="font-size: 16px">Swinger Bypass</div>
                        <div class="flex" style="margin: 24px 0; justify-content: center"><img src="/assets/imgs/bypass_tooltip.png" style="width: 200px; height: 100%; border-radius: 0"/></div>
                        <div>It does not generate events that have occurred more than the set number of times.</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">0</div>
                </td>
                <td> 
                  <div *ngIf="!isEditMode">{{originSiteSettings.swingerBypass}}</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="swingerBypass" [(ngModel)]="newSiteSettings.swingerBypass"/><span class="suffix">s</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Swinger Bypass Reset Timer</div>
                    <div class="tooltip-content" id="swinger-reset-timer-tooltip-box" (mouseenter)="setTooltipPosition('swinger-reset-timer-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="swinger-reset-timer-tooltip">
                        <div style="font-size: 16px">Swinger Bypass Reset Timer</div>
                        <div>Re-enables a swinger-bypassed trigger after the configured period, allowing the site to return to a more secure state. Set to 0 to disable (no automatic re-enable).</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">10 min</div>
                </td>
                <td>
                  <div *ngIf="!isEditMode">{{originSiteSettings.swingerBypassResetTimer}} min</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="swingerBypassResetTimer" [(ngModel)]="newSiteSettings.swingerBypassResetTimer" [min]="5" [max]="1440"/><span class="suffix">min</span>
                    </div>
                    <div class="range-description">5 min – 24 hours (1440 min)</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>MP4 Alarm Video Settings</div>
                    <div class="tooltip-content" id="video-settings-tooltip-box" (mouseenter)="setTooltipPosition('video-settings-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="video-settings-tooltip">
                        <div>The Bridge prepares and uploads an mp4 video based on the following configured pre/post-event video duration.<br/><br/></div>
                        <div class="v-center"><i class="material-icons" style="color:orange; margin-right: 8px;">warning</i>
                          <div>You will experience the post event video duration+ delay before viewing an event video in the monitoring portal. (e.g. 60 seconds post event video will show up in the monitoring portal 60+ seconds after an event occurs)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">Pre 7s / Post 25s</div>
                </td>
                <td> 
                  <div *ngIf="!isEditMode">Pre {{ originSiteSettings.mp4VideoSettings.pre }}s / Post {{ originSiteSettings.mp4VideoSettings.post }}s</div>
                  <ng-container *ngIf="isEditMode">
                    <div class="v-center" style="gap: 12px">
                      <div class="v-center" style="gap: 12px">
                        <div style="display: flex; flex-direction: column;">
                          <div>Pre Video</div>
                          <div class="range-description" style="margin: 0">Range: 5s - 10s</div>
                        </div>
                        <div class="input-suffix-container">
                          <input class="input-field" type="number" name="mp4VideoSettingsPre" [(ngModel)]="newSiteSettings.mp4VideoSettings.pre" [min]="5" [max]="10" (keyup)="validateMp4VideoSettingsPre()" (change)="validateMp4VideoSettingsPre()"/><span class="suffix">s</span>
                        </div>
                      </div>
                      <div class="v-center" style="gap: 12px">
                        <div style="display: flex; flex-direction: column;">
                          <div>Post Video</div>
                          <div class="range-description" style="margin: 0">Range: 10s - 60s</div>
                        </div>
                        <div class="input-suffix-container">
                          <input class="input-field" type="number" name="mp4VideoSettingsPost" [(ngModel)]="newSiteSettings.mp4VideoSettings.post" [min]="10" [max]="60" (keyup)="validateMp4VideoSettingsPost()" (change)="validateMp4VideoSettingsPost()"/><span class="suffix">s</span>
                        </div>
                      </div>
                      <div class="warning" *ngIf="isHasError.mp4VideoSettingsPre || isHasError.mp4VideoSettingsPost">
                         Please enter a ({{isHasError.mp4VideoSettingsPre ? 'pre' : 'post'}}) value within the allowed range.</div>
                      <div class="warning" *ngIf="isHasError.over20">
                         MP4 length exceeds Alarm Event Interval.<br/>
                        Set Alarm Event Interval to <b>{{ newSiteSettings.mp4VideoSettings.post }}s</b> or higher to prevent duplicates.
                      </div>
                    </div>
                  </ng-container>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Time Sync</div>
                    <div class="tooltip-content" id="time-sync-tooltip-box" (mouseenter)="setTooltipPosition('time-sync-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="time-sync-tooltip">
                        <div>It synchronizes the camera time to the bridge time. It is to minimize a time gap between the camera and the bridge, so to match the live/event video time and the time on OSD to the same.<br/><br/></div>
                        <div class="v-center"><i class="material-icons" style="color: orange; margin-right: 8px;">warning</i>
                          <div>When enabled, the bridge sets the camera time every hour. It will disable `DST` and `NTP time sync` automatically when setting time. It will set time zone as `UTC` automatically when setting time. It is enabled by default.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">Enabled</div>
                </td>
                <td> 
                  <div class="tag" *ngIf="!isEditMode" [ngClass]="computedTagStyleClass(originSiteSettings.timeSync)">{{ originSiteSettings.timeSync ? 'Enabled' : 'Disabled' }}</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <mat-slide-toggle [(ngModel)]="newSiteSettings.timeSync">
                      <div>{{ newSiteSettings.timeSync ? 'Enabled' : 'Disabled' }}</div>
                    </mat-slide-toggle>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Auto Set Stream</div>
                    <div class="tooltip-content" id="auto-set-stream-tooltip-box" (mouseenter)="setTooltipPosition('auto-set-stream-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="auto-set-stream-tooltip">
                        <div>When enabled, the video aspect ratio for the camera is automatically optimized by the Bridge. If this is disabled, the video screen ratio should be set manually on your device. For the Bridge to support a video stream, the Resolution should be 720p or less and the FPS between 3 & 10 FPS.</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">Enabled</div>
                </td>
                <td> 
                  <div class="tag" *ngIf="!isEditMode" [ngClass]="computedTagStyleClass(originSiteSettings.autoSetStream)">{{ originSiteSettings.autoSetStream ? 'Enabled' : 'Disabled' }}</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <mat-slide-toggle [(ngModel)]="newSiteSettings.autoSetStream">
                      <div>{{ newSiteSettings.autoSetStream ? 'Enabled' : 'Disabled' }}</div>
                    </mat-slide-toggle>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Default Camera Stream Settings</div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">720p, 8fps</div>
                </td>
                <td> 
                  <div *ngIf="!isEditMode">{{ computedStreamSpec() }}</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <select class="inner-selectbox" [(ngModel)]="newSiteSettings.autoSetStreamSpec" style="width: 200px">
                      <option value="720p@8fps@16GoP@1500vbr@h264">HD (720p, 8fps, VBR)</option>
                      <option value="360p@6fps@30GoP@500vbr@h264">SD (360p, 6fps, VBR)</option>
                      <option value="720p@8fps@16GoP@1500cbr@h264">HD (720p, 8fps, CBR)</option>
                      <option value="360p@6fps@30GoP@500cbr@h264">SD (360p, 6fps, CBR)</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Default Camera Audio Recording</div>
                    <div class="tooltip-content" id="audio-recording-tooltip-box" (mouseenter)="setTooltipPosition('audio-recording-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="audio-recording-tooltip">
                        <div>Allows audio to be recorded along with video when saving clips from the camera.</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">Enabled</div>
                </td>
                <td> 
                  <div class="tag" *ngIf="!isEditMode" [ngClass]="computedTagStyleClass(originSiteSettings.isAudioEnabled)">{{ originSiteSettings.isAudioEnabled ? 'Enabled' : 'Disabled' }}</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <mat-slide-toggle [(ngModel)]="newSiteSettings.isAudioEnabled">
                      <div>{{ newSiteSettings.isAudioEnabled ? 'Enabled' : 'Disabled' }}</div>
                    </mat-slide-toggle>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="between">
                    <div>Idle / Dormant</div>
                    <div class="tooltip-content" id="idle-dormant-tooltip-box" (mouseenter)="setTooltipPosition('idle-dormant-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="idle-dormant-tooltip">
                        <div>Configure activity monitoring thresholds.<br/>Idle: camera has no event activity for a set period.<br/>Dormant: camera has been inactive for an extended period, indicating a potential issue.</div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">Enabled<br/>Idle 3 day / Dormant 7 days</div>
                </td>
                <td>
                  <div *ngIf="!isEditMode">
                    <span class="tag" [ngClass]="computedTagStyleClass(originSiteSettings.isIdleDormantEnabled)">{{ originSiteSettings.isIdleDormantEnabled ? 'Enabled' : 'Disabled' }}</span>
                    <span *ngIf="originSiteSettings.isIdleDormantEnabled"> Idle {{ originSiteSettings.idleThreshold }} days / Dormant {{ originSiteSettings.dormantThreshold }} days</span>
                  </div>
                  <ng-container *ngIf="isEditMode">
                    <div class="v-center" style="gap: 12px">
                      <mat-slide-toggle [(ngModel)]="newSiteSettings.isIdleDormantEnabled">
                        <div>{{ newSiteSettings.isIdleDormantEnabled ? 'Enabled' : 'Disabled' }}</div>
                      </mat-slide-toggle>
                    <ng-container *ngIf="newSiteSettings.isIdleDormantEnabled">
                      <div class="v-center" style="gap: 12px">
                        <div style="display: flex; flex-direction: column;">
                          <div>Idle</div>
                          <div class="range-description" style="margin: 0">Range: 1 - 30 days</div>
                        </div>
                        <div class="input-suffix-container">
                          <input class="input-field" type="number" name="idleThreshold" [(ngModel)]="newSiteSettings.idleThreshold" [min]="1" [max]="30" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" (change)="validateIdleThreshold()"/><span class="suffix">days</span>
                        </div>
                      </div>
                      <div class="v-center" style="gap: 12px">
                        <div style="display: flex; flex-direction: column;">
                          <div>Dormant</div>
                          <div class="range-description" style="margin: 0">Range: 3 - 90 days</div>
                        </div>
                        <div class="input-suffix-container">
                          <input class="input-field" type="number" name="dormantThreshold" [(ngModel)]="newSiteSettings.dormantThreshold" [min]="3" [max]="90" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" (change)="validateDormantThreshold()"/><span class="suffix">days</span>
                        </div>
                      </div>
                      <div class="warning" *ngIf="isHasError.dormantThreshold">Dormant must be greater than Idle.</div>
                    </ng-container>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-container>